(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-benefits-page"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('garrnish-benefits-scroll'))customElements.define('garrnish-benefits-scroll',class extends HTMLElement{
 connectedCallback(){this.page=this.closest('.ge-benefits');this.nav=this.page.querySelector('.ge-directory');this.links=[...this.nav.querySelectorAll('a')];this.sections=[...this.page.querySelectorAll('[data-ge-benefit]')];this.update=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;const header=document.querySelector('.wt-header');const top=header?Math.max(0,header.getBoundingClientRect().bottom):80;const threshold=(innerWidth<750?this.nav.getBoundingClientRect().bottom:top+20)+24;let current=this.sections[0];for(const section of this.sections){if(section.getBoundingClientRect().top<=threshold)current=section}for(const link of this.links){const active=link.hash==='#'+current?.id;if(active){if(!link.hasAttribute('aria-current')&&innerWidth<750)this.nav.scrollTo({left:link.offsetLeft-this.nav.offsetWidth/2+link.offsetWidth/2,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});link.setAttribute('aria-current','location')}else link.removeAttribute('aria-current')}})};
 /* A directory link lands its headline at the same place every time (30 Oct 2026): 36px below the nav on desktop, 24px below the tab bar on phones. Below 1200px the nav hides when the page scrolls down and returns when it scrolls up, so the jump allows for where the nav will be. */
 this.jump=e=>{const link=e.target.closest('a[href^="#"]');const heading=link&&document.getElementById(decodeURIComponent(link.hash.slice(1)))?.querySelector('h2');if(!heading||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;e.preventDefault();const phone=innerWidth<750;const bar=document.querySelector('.page-header .wt-header');const y=heading.getBoundingClientRect().top+scrollY;const shown=(bar?.offsetHeight||0)+(phone?this.nav.offsetHeight:0)+(phone?24:36);const navShown=innerWidth>=1200||y-shown<scrollY;const offset=shown-(navShown?0:bar?.offsetHeight||0);scrollTo({top:Math.max(0,y-offset),behavior:'instant'});history.pushState(null,'',link.hash);heading.tabIndex=-1;heading.focus({preventScroll:true});this.update()};
 this.nav.addEventListener('click',this.jump);window.addEventListener('scroll',this.update,{passive:true});window.addEventListener('resize',this.update);this.update()}
 disconnectedCallback(){this.nav?.removeEventListener('click',this.jump);window.removeEventListener('scroll',this.update);window.removeEventListener('resize',this.update);cancelAnimationFrame(this.frame)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-daily-ritual"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('garrnish-daily-ritual-carousel')) {
    class PresellDailyRitualCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('.presell-daily-ritual__step'));
        this.status = this.querySelector('[data-status]');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.scrollFrame = null;
        this.activeIndex = 0;

        if (!this.viewport || !this.track || this.slides.length === 0) return;

        this.initialized = true;
        this.handleScroll = this.handleScroll.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);

        this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);

        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener('change', this.handleResize);
        } else {
          this.mobileQuery.addListener(this.handleResize);
        }

        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(this.handleResize);
          this.resizeObserver.observe(this.viewport);
        }

        this.refresh();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.viewport?.removeEventListener('scroll', this.handleScroll);
        this.viewport?.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);

        if (this.mobileQuery) {
          if (this.mobileQuery.removeEventListener) {
            this.mobileQuery.removeEventListener('change', this.handleResize);
          } else {
            this.mobileQuery.removeListener(this.handleResize);
          }
        }

        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.initialized = false;
      }

      isMobile() {
        return this.mobileQuery.matches;
      }

      handleResize() {
        this.refresh();
      }

      handleScroll() {
        if (!this.isMobile() || this.scrollFrame) return;

        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updateMobileIndex();
        });
      }

      handleKeydown(event) {
        if (!this.isMobile() || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        this.scrollToSlide(this.activeIndex + direction);
      }

      handleBlockSelect(event) {
        const selectedSlide = event.target.closest('.presell-daily-ritual__step');
        if (!selectedSlide) return;

        const selectedIndex = this.slides.indexOf(selectedSlide);
        if (selectedIndex >= 0) this.scrollToSlide(selectedIndex);
      }

      scrollToSlide(index) {
        if (!this.isMobile()) return;

        const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        const firstOffset = this.slides[0]?.offsetLeft || 0;
        const targetOffset = (this.slides[nextIndex]?.offsetLeft || firstOffset) - firstOffset;

        this.viewport.scrollTo({
          left: targetOffset,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        this.setActiveIndex(nextIndex);
      }

      updateMobileIndex() {
        if (!this.isMobile()) return;

        const firstOffset = this.slides[0]?.offsetLeft || 0;
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        this.slides.forEach((slide, index) => {
          const slideOffset = slide.offsetLeft - firstOffset;
          const distance = Math.abs(slideOffset - this.viewport.scrollLeft);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        this.setActiveIndex(nearestIndex);
      }

      setActiveIndex(index) {
        this.activeIndex = Math.max(0, Math.min(index, this.slides.length - 1));

        if (this.status) {
          this.status.textContent = this.status.dataset.statusTemplate.replaceAll('{number}', this.activeIndex + 1).replaceAll('{total}', this.slides.length);
        }
      }

      refresh() {
        if (this.isMobile()) {
          this.updateMobileIndex();
          return;
        }

        this.viewport.scrollLeft = 0;
        this.setActiveIndex(0);
      }
    }

    customElements.define('garrnish-daily-ritual-carousel', PresellDailyRitualCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.g-footer__toggle');
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', String(toggle.getAttribute('aria-expanded') !== 'true'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-page-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const menuLink = event.target.closest('.wt-drawer--garrnish-nav a[href]');
    if (menuLink && document.body.classList.contains('menu-open')) {
      document.querySelector('.wt-drawer--garrnish-nav .wt-drawer__close').click();
    }
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-password-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('garrnish-password-page')) {
    customElements.define(
      'garrnish-password-page',
      class GarrnishPasswordPage extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';

          this.openButtons = this.querySelectorAll('[data-gpp-dialog-open]');
          this.dialogs = this.querySelectorAll('[data-gpp-dialog]');
          this.inlineAccess = this.querySelector('[data-gpp-inline-access]');
          this.inlineTrigger = this.querySelector('[data-gpp-inline-trigger]');
          this.inlineForm = this.querySelector('.garrnish-password-inline-form');
          this.inlineInput = this.querySelector('[data-gpp-inline-input]');
          this.inlineSubmit = this.querySelector('[data-gpp-inline-submit]');
          this.inlineSubmitLabel = this.querySelector('[data-gpp-inline-submit-label]');
          this.inlineLoadingStatus = this.querySelector('[data-gpp-inline-loading-status]');
          this.inlineError = this.querySelector('[data-gpp-inline-error]');
          this.countdown = this.querySelector('[data-gpp-countdown]');
          this.accessActions = this.querySelector('[data-gpp-access-actions]');
          this.waitlistTrigger = this.querySelector('[data-gpp-waitlist-trigger]');
          this.phaseMode = this.dataset.phaseMode || 'automatic';
          this.videos = Array.from(this.querySelectorAll('.garrnish-password-page__video'));
          this.soundButton = this.querySelector('[data-gpp-sound-toggle]');
          this.klaviyoContainer = this.querySelector('.garrnish-password-dialog__klaviyo');
          this.waitlistDialog = this.klaviyoContainer?.closest('[data-gpp-dialog]');
          this.waitlistEyebrow = this.waitlistDialog?.querySelector('[data-gpp-waitlist-eyebrow]');
          this.waitlistHeading = this.waitlistDialog?.querySelector('[data-gpp-waitlist-heading]');
          this.waitlistDescription = this.waitlistDialog?.querySelector('[data-gpp-waitlist-description]');
          this.mobileQuery = window.matchMedia('(max-width: 899px)');
          this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.soundEnabled = false;
          this.handleMediaChange = () => this.syncVideos();
          this.handleDocumentPointerDown = (event) => {
            if (this.inlineAccess?.dataset.open !== 'true') return;
            if (this.inlineForm?.dataset.loading === 'true') return;
            if (this.inlineAccess.contains(event.target)) return;
            if (this.inlineInput?.value) return;
            this.setInlineAccessOpen(false, false);
          };
          this.handleInlineFocusOut = () => {
            window.requestAnimationFrame(() => {
              if (this.inlineFocusPending) return;
              if (this.inlineAccess?.dataset.open !== 'true') return;
              if (this.inlineForm?.dataset.loading === 'true') return;
              if (this.inlineAccess.contains(document.activeElement)) return;
              if (this.inlineInput?.value) return;
              this.setInlineAccessOpen(false, false);
            });
          };
          this.handleKlaviyoFormEvent = (event) => {
            const detail = event.detail || {};
            const formId = detail.formId || detail.formID;
            if (detail.type !== 'submit' || formId !== this.klaviyoContainer?.dataset.gppKlaviyoFormId) return;
            this.setKlaviyoSuccessState(true);
          };

          this.openButtons.forEach((button) => {
            button.addEventListener('click', () => this.openDialog(button));
          });

          if (this.inlineTrigger) {
            this.inlineTrigger.addEventListener('click', () => this.setInlineAccessOpen(true));
          }

          if (this.inlineInput) {
            this.inlineInput.addEventListener('input', () => this.clearInlineError());
            this.inlineInput.addEventListener('keydown', (event) => {
              if (event.key !== 'Escape') return;
              event.preventDefault();
              event.stopPropagation();
              this.setInlineAccessOpen(false);
            });
          }

          if (this.inlineAccess) {
            this.inlineAccess.addEventListener('focusout', this.handleInlineFocusOut);
            document.addEventListener('pointerdown', this.handleDocumentPointerDown);
          }

          if (this.inlineForm) {
            this.inlineForm.addEventListener('submit', () => this.setInlineLoading(true));
          }

          this.dialogs.forEach((dialog) => {
            dialog.querySelectorAll('[data-gpp-dialog-close]').forEach((button) => {
              button.addEventListener('click', () => dialog.close());
            });

            dialog.addEventListener('click', (event) => {
              if (event.target === dialog) dialog.close();
            });

            dialog.addEventListener('close', () => {
              const trigger = this.querySelector(`[aria-controls="${dialog.id}"]`);
              if (trigger) trigger.focus();
            });
          });

          if (this.soundButton) {
            this.soundButton.addEventListener('click', () => this.toggleSound());
          }

          if (this.klaviyoContainer) {
            window.addEventListener('klaviyoForms', this.handleKlaviyoFormEvent);
          }

          this.mobileQuery.addEventListener('change', this.handleMediaChange);
          this.motionQuery.addEventListener('change', this.handleMediaChange);

          const invalidPassword = this.querySelector('input[name="password"][aria-invalid="true"]');
          const waitlistSuccess = this.querySelector('[data-gpp-waitlist-success]');
          const invalidWaitlist = this.querySelector('input[name="contact[email]"][aria-invalid="true"]');

          if (this.inlineAccess && this.inlineTrigger && this.inlineForm) {
            this.inlineAccess.dataset.inlineReady = 'true';
            this.inlineTrigger.hidden = false;
            this.setInlineAccessOpen(Boolean(invalidPassword), Boolean(invalidPassword));
          }
          if (waitlistSuccess || invalidWaitlist) {
            this.showDialog((waitlistSuccess || invalidWaitlist).closest('dialog'));
          }

          this.syncVideos();
          this.startCountdown();
        }

        disconnectedCallback() {
          if (this.countdownTimer) window.clearInterval(this.countdownTimer);
          this.mobileQuery?.removeEventListener('change', this.handleMediaChange);
          this.motionQuery?.removeEventListener('change', this.handleMediaChange);
          this.inlineAccess?.removeEventListener('focusout', this.handleInlineFocusOut);
          document.removeEventListener('pointerdown', this.handleDocumentPointerDown);
          window.removeEventListener('klaviyoForms', this.handleKlaviyoFormEvent);
          this.videos?.forEach((video) => video.pause());
        }

        setKlaviyoSuccessState(isSuccess) {
          if (!this.waitlistDialog || !this.waitlistEyebrow) return;

          const label = isSuccess
            ? this.waitlistEyebrow.dataset.successLabel
            : this.waitlistEyebrow.dataset.defaultLabel;
          if (label) this.waitlistEyebrow.textContent = label;
          if (this.waitlistHeading) this.waitlistHeading.hidden = isSuccess;
          if (this.waitlistDescription) this.waitlistDescription.hidden = isSuccess;
          this.waitlistDialog.dataset.gppWaitlistSuccess = String(isSuccess);

          const labelledBy = isSuccess ? this.waitlistEyebrow.id : this.waitlistHeading?.id;
          if (labelledBy) this.waitlistDialog.setAttribute('aria-labelledby', labelledBy);
        }

        openDialog(button) {
          this.setInlineAccessOpen(false, false);
          const dialog = this.querySelector(`#${CSS.escape(button.dataset.gppDialogOpen)}`);
          this.showDialog(dialog);
        }

        setInlineAccessOpen(isOpen, shouldFocus = true) {
          if (!this.inlineAccess || !this.inlineTrigger || !this.inlineForm) return;
          this.inlineFocusPending = isOpen && shouldFocus;
          if (isOpen) this.syncInlineStart();
          if (!isOpen) {
            this.setInlineLoading(false);
            this.clearInlineError();
          }
          this.inlineAccess.dataset.open = String(isOpen);
          this.inlineTrigger.setAttribute('aria-expanded', String(isOpen));
          this.inlineTrigger.hidden = isOpen;
          this.inlineForm.hidden = !isOpen;

          if (!shouldFocus) {
            this.inlineFocusPending = false;
            return;
          }
          const focusTarget = isOpen ? this.inlineInput : this.inlineTrigger;
          if (focusTarget) {
            window.requestAnimationFrame(() => {
              focusTarget.focus();
              this.inlineFocusPending = false;
            });
          } else {
            this.inlineFocusPending = false;
          }
        }

        clearInlineError() {
          if (this.inlineError) this.inlineError.hidden = true;
          if (this.inlineInput) {
            this.inlineInput.removeAttribute('aria-invalid');
            this.inlineInput.removeAttribute('aria-describedby');
          }
        }

        syncInlineStart() {
          if (!this.inlineAccess || !this.inlineTrigger || this.inlineTrigger.hidden) return;
          const accessRect = this.inlineAccess.getBoundingClientRect();
          const triggerRect = this.inlineTrigger.getBoundingClientRect();
          const start = Math.max(0, triggerRect.left - accessRect.left);
          const end = Math.max(0, accessRect.right - triggerRect.right - 44);
          this.inlineAccess.style.setProperty('--gpp-inline-start', `${start}px`);
          this.inlineAccess.style.setProperty('--gpp-inline-end', `${end}px`);
        }

        setInlineLoading(isLoading) {
          if (!this.inlineForm) return;
          this.inlineForm.dataset.loading = String(isLoading);
          if (this.inlineInput) this.inlineInput.readOnly = isLoading;
          if (this.inlineSubmit) {
            this.inlineSubmit.disabled = isLoading;
            this.inlineSubmit.setAttribute('aria-busy', String(isLoading));
            const loadingLabel = this.inlineLoadingStatus?.dataset.loadingLabel;
            if (isLoading && loadingLabel) this.inlineSubmit.setAttribute('aria-label', loadingLabel);
            if (!isLoading && this.inlineSubmitLabel) {
              this.inlineSubmit.setAttribute('aria-label', this.inlineSubmitLabel.textContent.trim());
            }
          }
          if (this.inlineLoadingStatus) {
            this.inlineLoadingStatus.textContent = isLoading ? this.inlineLoadingStatus.dataset.loadingLabel || '' : '';
          }
        }

        showDialog(dialog) {
          if (!dialog || dialog.open) return;
          this.dialogs.forEach((openDialog) => {
            if (openDialog.open) openDialog.close();
          });
          dialog.showModal();
          const focusTarget = dialog.querySelector('input') || dialog.querySelector('button');
          if (focusTarget) window.requestAnimationFrame(() => focusTarget.focus());
        }

        syncVideos() {
          if (!this.videos.length) return;

          this.activeVideo = this.videos.find((video) => window.getComputedStyle(video).display !== 'none') || null;
          if (!this.activeVideo) this.soundEnabled = false;

          this.videos.forEach((video) => {
            if (video !== this.activeVideo) {
              video.pause();
              video.muted = true;
              return;
            }

            video.muted = !this.soundEnabled;
            if (!this.motionQuery.matches || this.soundEnabled) {
              const playPromise = video.play();
              if (playPromise) playPromise.catch(() => {});
            } else {
              video.pause();
            }
          });

          this.updateSoundButton();
        }

        toggleSound() {
          if (!this.activeVideo) return;
          this.soundEnabled = !this.soundEnabled;
          this.videos.forEach((video) => {
            video.muted = true;
          });
          this.activeVideo.muted = !this.soundEnabled;
          const playPromise = this.activeVideo.play();
          if (playPromise) playPromise.catch(() => {});
          this.updateSoundButton();
        }

        updateSoundButton() {
          if (!this.soundButton) return;
          this.soundButton.hidden = !this.activeVideo;
          this.soundButton.dataset.sound = this.soundEnabled ? 'on' : 'off';
          this.soundButton.setAttribute(
            'aria-label',
            this.soundEnabled ? this.soundButton.dataset.soundOffLabel : this.soundButton.dataset.soundOnLabel
          );
        }

        setLaunchPhase(phase) {
          const presaleEnded = phase === 'ended';
          const nextPhase = phase === 'live' ? 'live' : 'waitlist';
          this.dataset.launchPhase = nextPhase;
          this.dataset.presaleEnded = String(presaleEnded);
          this.setPostPresaleState(presaleEnded);

          if (!this.accessActions || !this.inlineAccess || !this.waitlistTrigger) return;
          const firstAction = nextPhase === 'live' ? this.inlineAccess : this.waitlistTrigger;
          const secondAction = nextPhase === 'live' ? this.waitlistTrigger : this.inlineAccess;
          if (this.accessActions.firstElementChild === firstAction) return;
          this.accessActions.append(firstAction, secondAction);
        }

        setPostPresaleState(isEnded) {
          const waitlistSucceeded = this.waitlistDialog?.dataset.gppWaitlistSuccess === 'true';

          if (!waitlistSucceeded) {
            if (this.waitlistEyebrow) {
              const eyebrow = isEnded
                ? this.waitlistEyebrow.dataset.endedLabel
                : this.waitlistEyebrow.dataset.defaultLabel;
              if (eyebrow) this.waitlistEyebrow.textContent = eyebrow;
            }
            if (this.waitlistHeading) {
              const heading = isEnded
                ? this.waitlistHeading.dataset.endedHeading
                : this.waitlistHeading.dataset.defaultHeading;
              if (heading) this.waitlistHeading.textContent = heading;
            }
            if (this.waitlistDescription) {
              const description = isEnded
                ? this.waitlistDescription.dataset.endedDescription
                : this.waitlistDescription.dataset.defaultDescription;
              if (description) this.waitlistDescription.textContent = description;
            }
          }

        }

        startCountdown() {
          if (!this.countdown) {
            let phase = 'waitlist';
            if (this.phaseMode === 'live') phase = 'live';
            if (this.phaseMode === 'ended') phase = 'ended';
            this.setLaunchPhase(phase);
            return;
          }

          const targetTime = Date.parse(this.countdown.dataset.target);
          const endTime = Date.parse(this.countdown.dataset.endTarget);
          const value = this.countdown.querySelector('[data-gpp-countdown-value]');
          const prefix = this.countdown.dataset.prefix || '';
          const liveLabel = this.countdown.dataset.liveLabel || '';
          const endedLabel = this.countdown.dataset.endedLabel || '';
          const daysShort = this.countdown.dataset.daysShort || '';
          const hoursShort = this.countdown.dataset.hoursShort || '';
          const minutesShort = this.countdown.dataset.minutesShort || '';
          const daysLabel = this.countdown.dataset.daysLabel || '';
          const hoursLabel = this.countdown.dataset.hoursLabel || '';
          const minutesLabel = this.countdown.dataset.minutesLabel || '';

          if (this.phaseMode === 'live') {
            this.setLaunchPhase('live');
            this.countdown.textContent = liveLabel;
            this.countdown.setAttribute('aria-label', liveLabel);
            return;
          }

          if (this.phaseMode === 'ended') {
            this.setLaunchPhase('ended');
            this.countdown.hidden = false;
            this.countdown.textContent = endedLabel;
            this.countdown.setAttribute('aria-label', endedLabel);
            return;
          }

          if (!Number.isFinite(targetTime)) {
            this.setLaunchPhase('waitlist');
            this.countdown.hidden = true;
            return;
          }

          const update = () => {
            const now = Date.now();
            const remaining = targetTime - now;

            if (this.phaseMode === 'automatic' && Number.isFinite(endTime) && now >= endTime) {
              this.setLaunchPhase('ended');
              this.countdown.hidden = false;
              this.countdown.textContent = endedLabel;
              this.countdown.setAttribute('aria-label', endedLabel);
              if (this.countdownTimer) window.clearInterval(this.countdownTimer);
              return;
            }

            if (remaining <= 0) {
              if (this.phaseMode === 'waitlist') {
                this.setLaunchPhase('waitlist');
                this.countdown.hidden = true;
                if (this.countdownTimer) window.clearInterval(this.countdownTimer);
                return;
              }

              this.setLaunchPhase('live');
              this.countdown.hidden = false;
              this.countdown.textContent = liveLabel;
              this.countdown.setAttribute('aria-label', liveLabel);
              if (!Number.isFinite(endTime) && this.countdownTimer) window.clearInterval(this.countdownTimer);
              return;
            }

            this.setLaunchPhase('waitlist');
            this.countdown.hidden = false;
            const totalMinutes = Math.floor(remaining / 60000);
            const days = Math.floor(totalMinutes / 1440);
            const hours = Math.floor((totalMinutes % 1440) / 60);
            const minutes = totalMinutes % 60;
            value.textContent = `${days}${daysShort} ${hours}${hoursShort} ${minutes}${minutesShort}`;
            this.countdown.setAttribute(
              'aria-label',
              `${prefix} ${days} ${daysLabel}, ${hours} ${hoursLabel}, ${minutes} ${minutesLabel}`
            );
          };

          this.countdownTimer = window.setInterval(update, 1000);
          update();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-results-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('garrnish-results-carousel')) {
    class PresellBeforeAfterCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot-index]'));
        this.pagination = this.querySelector('.presell-before-after__pagination');
        this.stage = this.querySelector('[data-stage]');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.status = this.querySelector('[data-status]');
        this.swipeHint = this.querySelector('[data-swipe-hint]');

        if (!this.viewport || !this.track || this.slides.length === 0) return;

        this.initialized = true;
        this.activeIndex = 0;
        this.scrollFrame = null;
        this.desktopQuery = window.matchMedia('(min-width: 990px)');

        this.handleResize = this.handleResize.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handlePointerMove = this.handlePointerMove.bind(this);
        this.handlePointerUp = this.handlePointerUp.bind(this);
        this.handleDragClick = this.handleDragClick.bind(this);

        this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.handleKeydown);
        this.viewport.addEventListener('pointerdown', this.handlePointerDown);
        this.viewport.addEventListener('pointermove', this.handlePointerMove);
        this.viewport.addEventListener('pointerup', this.handlePointerUp);
        this.viewport.addEventListener('pointercancel', this.handlePointerUp);
        this.viewport.addEventListener('click', this.handleDragClick, true);
        this.viewport.addEventListener('dragstart', (event) => event.preventDefault());
        this.previousButton?.addEventListener('click', () => this.goTo(this.activeIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.activeIndex + 1));
        this.addEventListener('shopify:block:select', this.handleBlockSelect);

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dotIndex)));
        });

        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.viewport);
        this.setupVideos();
        this.observeSwipeHint();
        this.refresh();
      }

      disconnectedCallback() {
        this.videoObserver?.disconnect();
        this.videoEvents?.abort();
        this.videos?.forEach((video) => video.pause());
        this.resizeObserver?.disconnect();
        this.viewport?.removeEventListener('scroll', this.handleScroll);
        this.viewport?.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.hintObserver?.disconnect();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.initialized = false;
      }

      setupVideos() {
        this.videos = Array.from(this.querySelectorAll('[data-result-video]'));
        this.visibleVideos = new Set();
        this.videoEvents = new AbortController();
        const options = { signal: this.videoEvents.signal };
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.motionQuery.addEventListener('change', () => this.syncVideos(), options);
        document.addEventListener('visibilitychange', () => this.syncVideos(), options);
        this.videos.forEach((video) => {
          video.addEventListener('loadeddata', () => video.classList.add('is-ready'), options);
          video.addEventListener('error', () => {
            video.classList.remove('is-ready');
            video.pause();
          }, options);
        });
        if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5) this.visibleVideos.add(entry.target);
              else this.visibleVideos.delete(entry.target);
            });
            this.syncVideos();
            this.loadNextClips();
          }, { threshold: [0, 0.5] });
          this.videos.forEach((video) => this.videoObserver.observe(video));
        }
      }

      loadVideo(video, ahead = false) {
        if (video.getAttribute('src') && !video.error) return;
        if (ahead) video.preload = 'auto';
        const sources = Array.from(video.querySelectorAll('source[data-src]'))
          .sort((a, b) => Number(a.dataset.width) - Number(b.dataset.width));
        const targetWidth = video.clientWidth * Math.min(window.devicePixelRatio || 1, 2);
        const source = sources.find((item) => Number(item.dataset.width) >= targetWidth) || sources.at(-1);
        if (!source) return;
        video.src = source.dataset.src;
        video.load();
      }

      // While a card's clips play, download the next card with clips, so a swipe shows them playing straight away
      // (2 Nov 2026). Only runs once the visitor has reached the results row, so it doesn't affect page load.
      loadNextClips() {
        if (this.motionQuery.matches) return;
        this.visibleVideos.forEach((video) => {
          let card = video.closest('[data-slide]')?.nextElementSibling;
          while (card && !card.querySelector('[data-result-video]')) card = card.nextElementSibling;
          card?.querySelectorAll('[data-result-video]').forEach((next) => this.loadVideo(next, true));
        });
      }

      syncVideos() {
        this.videos.forEach((video) => {
          const shouldPlay = this.visibleVideos.has(video) && !document.hidden && !this.motionQuery.matches;
          if (shouldPlay) {
            this.loadVideo(video);
            if (video.paused) video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      observeSwipeHint() {
        if (!this.swipeHint || !('IntersectionObserver' in window)) return;

        this.hintObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          this.classList.add('is-swipe-hint-visible');
          this.hintObserver.disconnect();
        }, { threshold: 0.6 });

        this.hintObserver.observe(this.swipeHint);
      }

      handleResize() {
        this.refresh();
      }

      handleScroll() {
        if (this.scrollFrame) return;

        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updateIndex();
        });
      }

      isDesktopCarousel() {
        return this.desktopQuery.matches && this.slides.length > 3;
      }

      // Mouse drag (desktop): the row follows the mouse, then settles on the nearest card in the drag's direction.
      handlePointerDown(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0 || !this.isDesktopCarousel()) return;
        this.drag = { x: event.clientX, left: this.viewport.scrollLeft, id: event.pointerId, moving: false };
        this.dragged = false;
      }

      handlePointerMove(event) {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const distance = event.clientX - this.drag.x;

        if (!this.drag.moving) {
          if (Math.abs(distance) < 6) return;
          this.drag.moving = true;
          this.viewport.setPointerCapture(this.drag.id);
          this.viewport.classList.add('is-dragging');
          window.getSelection()?.removeAllRanges();
        }

        this.viewport.scrollLeft = this.drag.left - distance;
      }

      handlePointerUp() {
        if (!this.drag) return;
        const { moving, left } = this.drag;
        this.drag = null;
        if (!moving) return;

        this.dragged = true;
        const step = this.slideStep();
        const position = this.viewport.scrollLeft / step;
        const moved = this.viewport.scrollLeft - left;
        let target = Math.round(position);
        if (moved > 40) target = Math.ceil(position);
        if (moved < -40) target = Math.floor(position);

        this.scrollToSlide(target);
        const release = () => this.viewport.classList.remove('is-dragging');
        if ('onscrollend' in window) this.viewport.addEventListener('scrollend', release, { once: true });
        setTimeout(release, 700);
      }

      handleDragClick(event) {
        if (!this.dragged) return;
        this.dragged = false;
        event.preventDefault();
        event.stopPropagation();
      }

      slideStep() {
        return this.slides.length > 1 ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.viewport.clientWidth;
      }

      handleKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;

        this.scrollToSlide(this.activeIndex + direction);
      }

      handleBlockSelect(event) {
        const selectedSlide = event.target.closest('[data-slide]');
        if (!selectedSlide) return;

        const selectedIndex = this.slides.indexOf(selectedSlide);
        if (selectedIndex < 0) return;

        this.scrollToSlide(selectedIndex);
      }

      goTo(index) {
        this.scrollToSlide(index);
      }

      // Last index a dot can show: on desktop three cards are in view, so the row stops with the last card on the right.
      maximumIndex() {
        return this.desktopQuery.matches ? Math.max(0, this.slides.length - 3) : this.slides.length - 1;
      }

      scrollToSlide(index) {
        const nextIndex = Math.max(0, Math.min(index, this.maximumIndex()));
        const firstOffset = this.slides[0]?.offsetLeft || 0;
        const targetOffset = (this.slides[nextIndex]?.offsetLeft || firstOffset) - firstOffset;

        this.viewport.scrollTo({
          left: targetOffset,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        this.setActiveIndex(nextIndex);
      }

      updateIndex() {
        const firstOffset = this.slides[0]?.offsetLeft || 0;
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        this.slides.forEach((slide, index) => {
          const slideOffset = slide.offsetLeft - firstOffset;
          const distance = Math.abs(slideOffset - this.viewport.scrollLeft);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        this.setActiveIndex(Math.min(nearestIndex, this.maximumIndex()));
      }

      setActiveIndex(index) {
        this.activeIndex = index;
        this.dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
        });
        this.updatePagination();
        this.updateStatus(index);
      }

      updatePagination() {
        if (!this.pagination) return;

        const maximum = this.maximumIndex();
        this.pagination.hidden = maximum === 0;
        this.dots.forEach((dot, index) => { dot.hidden = index > maximum; });
        this.updateArrows();
      }

      // Desktop arrows show only when they can move the row (judged from the scroll position, so they stay right mid-scroll).
      updateArrows() {
        if (!this.previousButton || !this.nextButton) return;

        const desktop = this.isDesktopCarousel();
        const left = this.viewport.scrollLeft;
        const end = this.viewport.scrollWidth - this.viewport.clientWidth;
        this.previousButton.hidden = !desktop || left <= 2;
        this.nextButton.hidden = !desktop || left >= end - 2;
      }

      // Centre the arrows on the card and keep them inside the page margin (56 px out, or less on narrow screens).
      positionArrows() {
        if (!this.stage || !this.previousButton || !this.isDesktopCarousel()) return;

        const card = this.slides[0].querySelector('.presell-before-after__card-surface') || this.slides[0];
        const stageRect = this.stage.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const room = Math.min(stageRect.left, document.documentElement.clientWidth - stageRect.right);
        this.stage.style.setProperty('--results-arrow-y', `${cardRect.top - stageRect.top + cardRect.height / 2}px`);
        this.stage.style.setProperty('--results-arrow-offset', `${Math.max(0, Math.min(56, room - 4))}px`);
      }

      updateStatus(index) {
        if (!this.status) return;
        this.status.textContent = this.status.dataset.statusTemplate.replaceAll('{number}', index + 1).replaceAll('{total}', this.slides.length);
      }

      refresh() {
        this.track.style.transform = '';
        this.updateIndex();
        this.positionArrows();
      }
    }

    customElements.define('garrnish-results-carousel', PresellBeforeAfterCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-social-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('garrnish-social-proof')) {
    class InfiniteCardCarousel extends HTMLElement {
      constructor() {
        super();
        this.elapsed = 0.5;
        this.lastTimestamp = null;
        this.frameId = null;
        this.inView = true;
        this.editorPaused = false;
        this.handleResize = this.handleResize.bind(this);
        this.handleMotionChange = this.handleMotionChange.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
        this.animate = this.animate.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;

        this.viewport = this.querySelector('.infinite-card-carousel__viewport');
        this.stage = this.querySelector('.infinite-card-carousel__stage');
        this.orbits = Array.from(this.querySelectorAll('.infinite-card-carousel__orbit'));
        this.cards = Array.from(this.querySelectorAll('.infinite-card-carousel__card'));

        if (!this.viewport || !this.stage || this.orbits.length === 0 || this.cards.length === 0) return;

        this.initialized = true;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.motionQuery.addEventListener('change', this.handleMotionChange);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.viewport);

        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            this.inView = entries[0].isIntersecting;
            this.updateAnimation();
          },
          { rootMargin: '200px 0px' }
        );
        this.intersectionObserver.observe(this);

        this.classList.add('is-orbit-ready');
        this.measure();
        this.updateAnimation();
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.stopAnimation();
        this.resizeObserver.disconnect();
        this.intersectionObserver.disconnect();
        this.motionQuery.removeEventListener('change', this.handleMotionChange);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
        this.initialized = false;
      }

      handleResize() {
        this.measure();
      }

      handleMotionChange() {
        this.updateAnimation();
      }

      handleBlockSelect() {
        this.editorPaused = true;
        this.stopAnimation();
      }

      handleBlockDeselect() {
        this.editorPaused = false;
        this.updateAnimation();
      }

      measure() {
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        const visibleCards = isDesktop
          ? Number(this.dataset.visibleCardsDesktop)
          : Number(this.dataset.visibleCardsMobile);
        const fanWidth = isDesktop
          ? Math.min(this.viewport.clientWidth, Number(this.dataset.fanWidthDesktop))
          : this.viewport.clientWidth;
        const edgeCrop = isDesktop
          ? Number(this.dataset.edgeCropDesktop) / 100
          : Number(this.dataset.edgeCropMobile) / 100;
        const cardSpacing = Number(this.dataset.cardSpacing) / 100;
        const bottomClearance = isDesktop
          ? Number(this.dataset.bottomClearanceDesktop)
          : Number(this.dataset.bottomClearanceMobile);
        const cardHeights = this.cards.map((card) => card.offsetHeight);
        const cardHeight = Math.max(...cardHeights);
        const cardWidth = this.cards[0].offsetWidth;
        const orbitDiameter = this.orbits[0].offsetWidth;
        const radius = orbitDiameter / 2;
        const edgeCentreX = fanWidth / 2 + cardWidth * (edgeCrop - 0.5);
        const boundaryRatio = Math.min(0.92, Math.max(0.05, edgeCentreX / radius));
        const boundaryAngle = Math.asin(boundaryRatio);
        const activeSpan = visibleCards + 1;
        const minimumSlotAngle = Math.asin(Math.min(0.75, (cardWidth * cardSpacing) / radius));
        const spacingTravelAngle = minimumSlotAngle * activeSpan / 2;
        const travelAngle = Math.min(
          Math.PI * 0.44,
          Math.max(boundaryAngle * (activeSpan / visibleCards), spacingTravelAngle)
        );

        this.layout = {
          viewportWidth: this.viewport.clientWidth,
          cardWidth,
          cardHeight,
          visibleCards,
          activeSpan,
          travelAngle,
          speed: Number(this.dataset.animationSpeed) / 100
        };

        const orbitBaseTop = cardHeight / 2;
        const rotationOffsets = this.cards.map((card) => {
          const value = getComputedStyle(card).getPropertyValue('--rotation-offset');
          return (Number.parseFloat(value) || 0) * Math.PI / 180;
        });
        let highestCardEdge = 0;
        let lowestCardEdge = cardHeight;
        const sampleCount = 64;

        rotationOffsets.forEach((rotationOffset) => {
          for (let sample = 0; sample <= sampleCount; sample += 1) {
            const orbitAngle = -travelAngle + (travelAngle * 2 * sample) / sampleCount;
            const cardAngle = orbitAngle + rotationOffset;
            const centreY = orbitBaseTop + radius * (1 - Math.cos(orbitAngle));
            const halfExtentY =
              Math.abs(Math.sin(cardAngle)) * cardWidth / 2
              + Math.abs(Math.cos(cardAngle)) * cardHeight / 2;

            highestCardEdge = Math.min(highestCardEdge, centreY - halfExtentY);
            lowestCardEdge = Math.max(lowestCardEdge, centreY + halfExtentY);
          }
        });

        const visibleArcDepth = Math.min(
          Math.max(0, lowestCardEdge - cardHeight),
          cardWidth * 0.32
        );
        const topInset = Math.ceil(Math.max(0, -highestCardEdge) + 12);
        const orbitTop = orbitBaseTop + topInset;

        this.stage.style.height = `${Math.ceil(
          topInset + cardHeight + visibleArcDepth + bottomClearance
        )}px`;
        this.orbits.forEach((orbit) => {
          orbit.style.top = `${orbitTop}px`;
        });
        this.renderFrame(this.motionQuery.matches ? 0 : this.elapsed);
      }

      updateAnimation() {
        if (this.motionQuery.matches) {
          this.stopAnimation();
          this.renderFrame(0);
          return;
        }

        if (!this.inView || this.editorPaused) {
          this.stopAnimation();
          return;
        }

        if (this.frameId === null) {
          this.frameId = requestAnimationFrame(this.animate);
        }
      }

      stopAnimation() {
        if (this.frameId !== null) {
          cancelAnimationFrame(this.frameId);
          this.frameId = null;
        }

        this.lastTimestamp = null;
      }

      animate(timestamp) {
        if (this.lastTimestamp !== null) {
          const delta = Math.min((timestamp - this.lastTimestamp) / 1000, 0.1);
          this.elapsed += delta;
        }

        this.lastTimestamp = timestamp;
        this.renderFrame(this.elapsed);
        this.frameId = requestAnimationFrame(this.animate);
      }

      renderFrame(elapsed) {
        if (!this.layout) return;

        const totalCards = this.orbits.length;
        const activeSpan = this.layout.activeSpan;

        this.orbits.forEach((orbit, index) => {
          const phase = (index + elapsed * this.layout.speed) % totalCards;

          if (phase >= activeSpan) {
            orbit.style.visibility = 'hidden';
            orbit.style.opacity = '0';
            return;
          }

          const progress = phase / activeSpan;
          const angle = this.layout.travelAngle - progress * this.layout.travelAngle * 2;
          const edgeDistance = Math.min(phase, activeSpan - phase);
          const opacity = Math.min(1, edgeDistance / 0.4);
          const angleDegrees = (angle * 180) / Math.PI;

          orbit.style.visibility = 'visible';
          orbit.style.opacity = String(opacity);
          orbit.style.zIndex = String(Math.round(10 + (activeSpan - phase) * 10));
          orbit.style.transform = `translate3d(-50%, 0, 0) rotate(${angleDegrees}deg)`;
        });
      }
    }

    customElements.define('garrnish-social-proof', InfiniteCardCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
